// owned
import ProviderType from '../provider-type.js'
import Provider from '../provider.js'
import ConsoleLogFactory from './console-log-factory.js'

export default class ConsoleProvider extends Provider {
  /**
   * Gets the provider type (Console).
   * @returns {string} "CONSOLE"
   * @override
   */
  getType () {
    return ProviderType.Console
  }

  /**
 * Creates a new Provider instance.
 * @param {Object} libraryModule - The library module to be used.
 * @param {Object} setting - Configuration settings for the provider.
 * @returns {ConsoleLogFactory} A new instance of ConsoleProvider.
 * @override
 */
  createLogFactory (libraryModule, setting) {
    return new ConsoleLogFactory(libraryModule, setting)
  }
}
